import { get, patch, post } from '@_shared/config';

import { userModel } from '../model';

export async function getUser() {
	return get<userModel.TUser>('/user/profile');
}

export function leaveUser(reason: string[], etc?: string) {
	return post('/settings/withdraw', {
		reason,
		etc,
	});
}

export async function updateNickname(nickname: string) {
	return patch('/user/nickname', {
		nickname,
	});
}

export async function checkNickname(nickname: string) {
	return get<{ message: string }>(`/user/nickname/${nickname}`);
}
